export interface DriftCardPosition {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
}

interface DriftCardPositionValue {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

const BASE_POSITIONS: DriftCardPositionValue[] = [
  { top: 9, left: 7 },
  { top: 23, left: 28 },
  { top: 8, right: 7 },
  { right: 26, bottom: 8 },
  { bottom: 7, left: 8 },
  { top: 45, left: 48 },
  { top: 6, left: 48 },
  { right: 8, bottom: 7 },
];

function getDriftCardPositionValues(index: number): DriftCardPositionValue {
  const safeIndex = Math.max(0, Math.floor(index));
  const base = BASE_POSITIONS[safeIndex % BASE_POSITIONS.length];
  const batchOffset = Math.min(Math.floor(safeIndex / BASE_POSITIONS.length) * 3, 18);
  return {
    ...(base.top !== undefined ? { top: Math.min(base.top + batchOffset, 82) } : {}),
    ...(base.right !== undefined ? { right: Math.min(base.right + batchOffset, 36) } : {}),
    ...(base.bottom !== undefined ? { bottom: Math.min(base.bottom + batchOffset, 30) } : {}),
    ...(base.left !== undefined ? { left: Math.min(base.left + batchOffset, 58) } : {}),
  };
}

export function getDriftCardPosition(index: number): DriftCardPosition {
  return Object.fromEntries(
    Object.entries(getDriftCardPositionValues(index)).map(([property, value]) => [property, `${value}%`]),
  );
}

export function getDriftCardPositionStyle(index: number) {
  return Object.entries(getDriftCardPosition(index)).map(([property, value]) => `${property}:${value}`).join(";");
}
